"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.io = io;
function io() {
    const hitEls = [...document.querySelectorAll('.hit')];
    const redoEls = [...document.querySelectorAll('.redo')];
    const scrFastEls = [...document.querySelectorAll('.scr-fast')];
    if (!hitEls.length && !redoEls.length && !scrFastEls.length)
        return;
    function animateCounter(selector, duration = 3000) {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            const targetNum = parseInt(element.dataset.num || '0', 10);
            if (targetNum === 0)
                return;
            const startTime = performance.now();
            const animate = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easeOut = 1 - Math.pow(1 - progress, 1);
                const currentValue = Math.floor(targetNum * easeOut);
                element.textContent = currentValue.toString();
                (progress < 1) ? requestAnimationFrame(animate) : element.textContent = targetNum.toString();
            };
            requestAnimationFrame(animate);
        });
    }
    ;
    // "HIT" logic:
    if (hitEls.length) {
        for (const el of hitEls)
            el.classList.add('start');
        const io1 = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const cls = entry.target.classList;
                if (entry.isIntersecting) {
                    switch (true) {
                        case cls.contains('hit') && cls.contains('counter-num1'):
                            setTimeout(() => animateCounter('.counter-num1', 2500), 10);
                            io1.unobserve(entry.target);
                            break;
                        case cls.contains('hit') && cls.contains('counter-num2'):
                            setTimeout(() => animateCounter('.counter-num2', 1500), 10);
                            io1.unobserve(entry.target);
                            break;
                        case cls.contains('hit') && cls.contains('counter-num3'):
                            setTimeout(() => animateCounter('.counter-num3', 1000), 10);
                            io1.unobserve(entry.target);
                            break;
                        case cls.contains('hit') && cls.contains('counter-num4'):
                            setTimeout(() => animateCounter('.counter-num4', 2000), 10);
                            io1.unobserve(entry.target);
                            break;
                        case cls.contains('hit'):
                            entry.target.classList.add('show');
                            io1.unobserve(entry.target);
                            break;
                    }
                    ;
                }
                else {
                    if (cls.contains('brand-wall') && entry.target['stopChyron']) {
                        entry.target['stopChyron']();
                    }
                }
                ;
            });
        }, {
            rootMargin: '-100px',
            threshold: 0,
        });
        for (const hit of hitEls)
            io1.observe(hit);
    }
    ;
    // "REDO" logic:
    if (redoEls.length) {
        for (const re of redoEls)
            re.classList.add('start');
        const ioRedo = new IntersectionObserver((entries) => {
            entries.forEach((en) => {
                const cls = en.target.classList;
                if (en.isIntersecting) {
                    switch (true) {
                        case cls.contains('redo'):
                            en.target.classList.add('show');
                            break;
                    }
                    ;
                }
                else {
                    switch (true) {
                        case cls.contains('redo'):
                            en.target.classList.remove('show');
                            break;
                    }
                    ;
                }
                ;
            });
        }, {
            rootMargin: '-20px 0px -20px 0px',
            threshold: 0,
        });
        for (const re of redoEls)
            ioRedo.observe(re);
    }
    ;
    // "SCR-FAST" logic:
    if (scrFastEls.length) {
        const mq = matchMedia('(min-width: 640px)');
        const activeFastTargets = new Map();
        let scrollHandler = null;
        let ioSF = null;
        let rafId = null;
        let ticking = false;
        let viewportCenter = window.innerHeight / 2;
        const handleScrollFast = () => {
            if (!ticking) {
                ticking = true;
                rafId = requestAnimationFrame(() => {
                    activeFastTargets.forEach(({ speed, halfHeight, isAbsolute }, target) => {
                        const rect = target.getBoundingClientRect();
                        const elementCenter = rect.top + halfHeight;
                        const transformAmount = (elementCenter - viewportCenter) * speed;
                        target.style.transform = isAbsolute ? `translate3d(0,${transformAmount - halfHeight}px,0)` : `translate3d(0,${transformAmount}px,0)`;
                    });
                    ticking = false;
                });
            }
        };
        const enableParallax = () => {
            viewportCenter = window.innerHeight / 2;
            scrFastEls.forEach(el => el.classList.add('start'));
            scrollHandler = handleScrollFast;
            window.addEventListener('scroll', scrollHandler, { passive: true });
            ioSF = new IntersectionObserver((entries) => {
                for (const en of entries) {
                    const cls = en.target.classList;
                    if (en.isIntersecting) {
                        const rect = en.target.getBoundingClientRect();
                        const halfHeight = rect.height * 0.5;
                        switch (true) {
                            case cls.contains('text-image__fig'):
                                activeFastTargets.set(en.target, { speed: 0.11, halfHeight, isAbsolute: true });
                                break;
                            case cls.contains('text-image__fig-shadow'):
                                activeFastTargets.set(en.target, { speed: 0.05, halfHeight, isAbsolute: true });
                                break;
                            case cls.contains('text-image-2__fig'):
                                activeFastTargets.set(en.target, { speed: 0.11, halfHeight, isAbsolute: false });
                                break;
                        }
                    }
                    else {
                        switch (true) {
                            case cls.contains('text-image__fig'):
                            case cls.contains('text-image__fig-shadow'):
                            case cls.contains('text-image-2__fig'):
                                activeFastTargets.delete(en.target);
                                break;
                        }
                    }
                }
            }, {
                rootMargin: '300px',
                threshold: 0,
            });
            scrFastEls.forEach(el => ioSF.observe(el));
            handleScrollFast();
        };
        const disableParallax = () => {
            if (scrollHandler) {
                window.removeEventListener('scroll', scrollHandler);
                scrollHandler = null;
            }
            if (rafId !== null) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
            if (ioSF) {
                ioSF.disconnect();
                ioSF = null;
            }
            activeFastTargets.clear();
            ticking = false;
            scrFastEls.forEach(el => {
                el.style.transform = '';
                el.classList.remove('start');
            });
        };
        const handleMediaChange = (e) => {
            if (e.matches) {
                enableParallax();
            }
            else {
                disableParallax();
            }
        };
        handleMediaChange(mq);
        mq.addEventListener('change', handleMediaChange);
    }
    ;
}
;
